var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#25282C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#2B2F32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 17.75V20.1667H23.8333C24 20.1667 24.0833 20.3333 24.0833 20.5L23.75 22.0833C23.75 22.1667 23.5833 22.25 23.5 22.25H21.6667V28.3333H19.1667V22.3333H17.75C17.5833 22.3333 17.5 22.25 17.5 22.0833V20.5C17.5 20.3333 17.5833 20.25 17.75 20.25H19.1667V17.5C19.1667 16.0833 20.25 15 21.6667 15H23.9167C24.0833 15 24.1667 15.0833 24.1667 15.25V17.25C24.1667 17.4167 24.0833 17.5 23.9167 17.5H21.9167C21.75 17.5 21.6667 17.5833 21.6667 17.75Z",
    stroke: "#F4FD84",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5003 28.3333H17.5003C13.3337 28.3333 11.667 26.6666 11.667 22.5V17.5C11.667 13.3333 13.3337 11.6666 17.5003 11.6666H22.5003C26.667 11.6666 28.3337 13.3333 28.3337 17.5V22.5C28.3337 26.6666 26.667 28.3333 22.5003 28.3333Z",
    stroke: "#F4FD84",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3036fb54f43ffc83afde321480f8277d.svg";
export { ForwardRef as ReactComponent };